import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '../stores/useAuthStore';

export default function ForcePasswordChangeRoute() {
  const mustChangePassword = useAuthStore((s) => s.mustChangePassword);
  if (mustChangePassword) return <Navigate to="/set-password" replace />;
  return <Outlet />;
}
